<template lang="html">
  <a
    class="copy"
    @click.prevent="copyToClipboard()"
  >
    <span>{{ $tc('ui.copy', Array.isArray(toCopy) ? toCopy.length : 1) }}</span>
    <span
      v-show="copied"
      class="UI-icon UI-checked"
    />
  </a>
</template>

<script>
export default {
  name: 'CopyClipboard',

  props: {
    toCopy: { type: [String, Array], default: '' }
  },

  data () {
    return {
      copied: false
    }
  },

  computed: {
    textToCopy () {
      return Array.isArray(this.toCopy) ? this.toCopy.join('\n') : this.toCopy
    }
  },

  methods: {
    copyToClipboard () {
      var textArea = document.createElement('textarea')

      // Place in top-left corner of screen regardless of scroll position.
      textArea.style.position = 'fixed'
      textArea.style.top = 0
      textArea.style.left = 0

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textArea.style.width = '2em'
      textArea.style.height = '2em'

      // We don't need padding, reducing the size if it does flash render.
      textArea.style.padding = 0

      // Clean up any borders.
      textArea.style.border = 'none'
      textArea.style.outline = 'none'
      textArea.style.boxShadow = 'none'

      // Avoid flash of white box if rendered for any reason.
      textArea.style.background = 'transparent'

      textArea.value = this.textToCopy

      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        document.execCommand('copy')
        this.copied = true
        setTimeout(_ => {
          this.copied = false
        }, 700)
      } catch (err) {
        console.log('Oops, unable to copy')
      }

      document.body.removeChild(textArea)
    }
  }
}
</script>

<style lang="scss">
.copy{
  color: #A2b4b4;
  opacity: 0.4;
  cursor: pointer;
  font-size: 14px;

  &:hover{
    opacity: 0.9;
    color: white;
    span:first-of-type{
      text-decoration: underline;
    }
  }

  .UI-checked{
    color: #14c6ab;
    margin-left: 7px;
    line-height: 16px;
  }
}
</style>
